// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.lancer-marche-modal {
  background-color: #fffdfc;
  border-radius: 10px;
  padding: 2rem;
  width: 90%;
  max-width: 820px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.lancer-marche-modal h2 {
  color: #2c3948;
  font-size: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.lancer-marche-modal .form-group {
  margin-bottom: 1.5rem;
}

.lancer-marche-modal label {
  display: block;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3948;
}

.lancer-marche-modal input,
.lancer-marche-modal select {
  width: 100%;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1.4rem;
}

.lancer-marche-modal input:focus,
.lancer-marche-modal select:focus {
  outline: none;
  border-color: #f97316;
}

.lancer-marche-modal .error {
  border-color: #ef4444;
}

.lancer-marche-modal .error-message {
  color: #ef4444;
  font-size: 1.2rem;
  margin-top: 0.5rem;
  display: block;
}

.lancer-marche-modal .required {
  color: #ef4444;
}

.lancer-marche-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

/* Animation d'entrée */
.lancer-marche-modal {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* ── Titulaire rang 1 ─────────────────────────────────────────────── */

.lmm-titulaire-section {
  margin-top: 1.6rem;
  padding-top: 1.4rem;
  border-top: 1px solid #e5e7eb;
}

.lmm-titulaire-label {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 1rem;
}

.lmm-titulaire-loading,
.lmm-titulaire-none {
  font-size: 1.2rem;
  color: #6b7280;
  text-align: center;
  padding: 0.8rem;
}

.lmm-titulaire-infructueux {
  font-size: 1.25rem;
  color: #374151;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  text-align: center;
  padding: 1rem 1.4rem;
  margin-top: 0.4rem;
}

.lmm-titulaire-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.2rem;
  margin-top: 0.4rem;
}

.lmm-titulaire-card {
  pointer-events: none;
}

/* Reprise des styles prestataire-card pour la modale (autonome) */

.lancer-marche-modal .prestataire-card {
  background: white;
  border-radius: 12px;
  overflow: visible;
  position: relative;
  min-width: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
}

.lancer-marche-modal .prestataire-card-inner {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  border-radius: inherit;
  position: relative;
}

.lancer-marche-modal .prestataire-card-header {
  height: 120px;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  position: relative;
}

.lancer-marche-modal .prestataire-card-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lancer-marche-modal .prestataire-card-banner-placeholder {
  width: 100%;
  height: 100%;
}

.lancer-marche-modal .prestataire-card-logo-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
  width: 120px;
  height: 110px;
  background: white;
  border-radius: 10px;
  border: 2px solid #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.lancer-marche-modal .prestataire-card-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 6px;
}

.lancer-marche-modal .prestataire-card-logo-text {
  font-size: 1.5rem;
  font-weight: 800;
  color: #6b7280;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.lancer-marche-modal .prestataire-card-body {
  padding: 3.5rem 1.2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  flex: 1 1;
  text-align: center;
}

.lancer-marche-modal .prestataire-card-nom {
  font-weight: 700;
  font-size: 1.35rem;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  margin: 0 0 0.4rem;
}

.lmm-card-info {
  font-size: 1.2rem;
  color: #374151;
  text-align: center;
  width: 100%;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lmm-card-info a {
  color: inherit;
  text-decoration: none;
}

.lmm-card-info-label {
  font-weight: 600;
  color: #6b7280;
  margin-right: 0.3rem;
}

.lmm-card-info--contact {
  color: #1f2937;
  font-weight: 600;
  margin-top: 0.5rem;
}

.lancer-marche-modal .prestataire-card-type {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.25rem 0.55rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 700;
  background-color: #f97316;
  color: white;
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/composants/LancerMarcheModal/LancerMarcheModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,wEAAwE;;AAExE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kEAAkE;;AAElE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.lancer-marche-modal {\n  background-color: #fffdfc;\n  border-radius: 10px;\n  padding: 2rem;\n  width: 90%;\n  max-width: 820px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.lancer-marche-modal h2 {\n  color: #2c3948;\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.lancer-marche-modal .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.lancer-marche-modal label {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #2c3948;\n}\n\n.lancer-marche-modal input,\n.lancer-marche-modal select {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1.4rem;\n}\n\n.lancer-marche-modal input:focus,\n.lancer-marche-modal select:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.lancer-marche-modal .error {\n  border-color: #ef4444;\n}\n\n.lancer-marche-modal .error-message {\n  color: #ef4444;\n  font-size: 1.2rem;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.lancer-marche-modal .required {\n  color: #ef4444;\n}\n\n.lancer-marche-modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n/* Animation d'entrée */\n.lancer-marche-modal {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* ── Titulaire rang 1 ─────────────────────────────────────────────── */\n\n.lmm-titulaire-section {\n  margin-top: 1.6rem;\n  padding-top: 1.4rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.lmm-titulaire-label {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 1rem;\n}\n\n.lmm-titulaire-loading,\n.lmm-titulaire-none {\n  font-size: 1.2rem;\n  color: #6b7280;\n  text-align: center;\n  padding: 0.8rem;\n}\n\n.lmm-titulaire-infructueux {\n  font-size: 1.25rem;\n  color: #374151;\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  text-align: center;\n  padding: 1rem 1.4rem;\n  margin-top: 0.4rem;\n}\n\n.lmm-titulaire-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.2rem;\n  margin-top: 0.4rem;\n}\n\n.lmm-titulaire-card {\n  pointer-events: none;\n}\n\n/* Reprise des styles prestataire-card pour la modale (autonome) */\n\n.lancer-marche-modal .prestataire-card {\n  background: white;\n  border-radius: 12px;\n  overflow: visible;\n  position: relative;\n  min-width: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n}\n\n.lancer-marche-modal .prestataire-card-inner {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n  border-radius: inherit;\n  position: relative;\n}\n\n.lancer-marche-modal .prestataire-card-header {\n  height: 120px;\n  border-radius: 12px 12px 0 0;\n  overflow: hidden;\n  position: relative;\n}\n\n.lancer-marche-modal .prestataire-card-banner-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lancer-marche-modal .prestataire-card-banner-placeholder {\n  width: 100%;\n  height: 100%;\n}\n\n.lancer-marche-modal .prestataire-card-logo-wrapper {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 30px;\n  width: 120px;\n  height: 110px;\n  background: white;\n  border-radius: 10px;\n  border: 2px solid #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1;\n}\n\n.lancer-marche-modal .prestataire-card-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 6px;\n}\n\n.lancer-marche-modal .prestataire-card-logo-text {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #6b7280;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.lancer-marche-modal .prestataire-card-body {\n  padding: 3.5rem 1.2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  flex: 1;\n  text-align: center;\n}\n\n.lancer-marche-modal .prestataire-card-nom {\n  font-weight: 700;\n  font-size: 1.35rem;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  width: 100%;\n  margin: 0 0 0.4rem;\n}\n\n.lmm-card-info {\n  font-size: 1.2rem;\n  color: #374151;\n  text-align: center;\n  width: 100%;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lmm-card-info a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.lmm-card-info-label {\n  font-weight: 600;\n  color: #6b7280;\n  margin-right: 0.3rem;\n}\n\n.lmm-card-info--contact {\n  color: #1f2937;\n  font-weight: 600;\n  margin-top: 0.5rem;\n}\n\n.lancer-marche-modal .prestataire-card-type {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  padding: 0.25rem 0.55rem;\n  border-radius: 20px;\n  font-size: 1rem;\n  font-weight: 700;\n  background-color: #f97316;\n  color: white;\n  z-index: 2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
